var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5567 14.7787V27.0989L27.712 23.3203L22.8685 27.0989V14.7787L27.712 11L32.5567 14.7787ZM12.8434 34.9175L8 38.6962V26.3759L12.8434 22.5973V34.9175ZM35.1469 22.0087H35.1456V31.1452L27.712 36.9432L20.2783 31.1452V22.0087V16.7993L15.4336 20.5779V32.8982L15.4619 32.8754V33.4449L27.712 43L39.962 33.4449V32.8754L39.9903 32.8982V20.5779L35.1469 16.7993V22.0087ZM42.5805 34.9175V22.5973L47.4252 26.3759V38.6962L42.5805 34.9175Z",
    fill: "url(#paint0_linear_1948_12445)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1948_12445",
    x1: 27.7122,
    y1: -8.49787,
    x2: 27.7122,
    y2: 46.8085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.373822,
    stopColor: "#B36EFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4876FB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.32f9439aaa7641fa1a8ab39f07541fe7.svg";
export { ForwardRef as ReactComponent };